import {isSelectiveAiDomains} from 'common/HelperFunctions'
import {Shield} from 'lucide-react'
import React from 'react'
import {useIntl} from 'react-intl'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from 'setup'

/**
 * Versi's footer follows the portal footer's own setting, `powered_by_text` (super admin →
 * application "Power By Text"): a white-label tenant that sets it sees only its text, never our
 * name. Every other tenant sees "Powered by Ilmversity" (Da1Timetable on its domains), linked as
 * the portal footer links it.
 */
const ChatbotPoweredBy: React.FC = () => {
  const intl = useIntl()
  const isAiSelectiveDomain = isSelectiveAiDomains()
  const generalSettings = useSelector<RootState>(
    ({mainReducer}) => mainReducer.generalSettings,
    shallowEqual
  ) as any

  const tenantPoweredByText =
    typeof generalSettings?.powered_by_text === 'string'
      ? isAiSelectiveDomain
        ? generalSettings.powered_by_text.replace(/ilmversity/gi, 'Da1Timetable')
        : generalSettings.powered_by_text
      : generalSettings?.powered_by_text

  return (
    <div className='chatbot-powered-by'>
      <span className='chatbot-powered-by__disclaimer'>
        {intl.formatMessage({id: 'CHATBOT.AI_DISCLAIMER'})}
      </span>
      <div className='chatbot-powered-by__brand'>
        <Shield size={12} className='chatbot-powered-by__icon' aria-hidden='true' />
        {tenantPoweredByText ? (
          <span
            className='chatbot-powered-by__tenant'
            dangerouslySetInnerHTML={{__html: tenantPoweredByText}}
          />
        ) : (
          <span data-testid='chatbot-powered-by-brand'>
            {intl.formatMessage(
              {id: 'CHATBOT.POWERED_BY_BRAND'},
              {
                brand: (
                  <a key='brand' href='https://ilmversity.com' target='_blank' rel='noreferrer' className='chatbot-powered-by__link'>
                    {isAiSelectiveDomain ? 'Da1Timetable' : 'Ilmversity'}
                  </a>
                ),
              }
            )}
          </span>
        )}
      </div>
    </div>
  )
}

export default ChatbotPoweredBy
